export const PRODUCT_TTILE = 'UltraTax CS support schedule';
export const NORMAL_HOURS_TEXT = 'Normal hours';
export const NORMAL_HOURS = 'Weekdays, 9 am to 8 pm ET ';
export const PH_NUMBER_TEXT = 'Phone number';
export const PH_NUMBER = '800-968-0600 (option 1)';
export const PAGE_TITLE = 'Support hours';
export const PAGE_DESCRIPTION =
  'Search or use the filters below to explore all support hours by quarter, days or times.';
export const DATA_URL = 'https://support.cchsfs.com/support/schedule';

export const DESKTOP_MIN_WIDTH = 768;
export const MOBILE_MAX_WIDTH = DESKTOP_MIN_WIDTH + 1;

export const PAGINATION_CONFIG = {
  '10': 5,
  '20': 4,
  '30': 3,
  '40': 2,
};

export const ITEMS_PER_PAGE_VALUE = 10;
export const INITIAL_PAGE_NUMBER = 1;
export const MAX_VISIBLE_PAGES = 5;
export const NEXT_LABEL_VALUE = 'Next';
export const PREVIOUS_LABEL_VALUE = 'Previous';
export const PAGINATION_LABEL_VALUE = 'Label';
export const PAGE = 'Page';
export const RESULTS_PER_PAGE_LABEL_VALUE = 'Items per page';
export const ROWS_PER_PAGE_LABEL_CONTENT = 'Showing';
export const GO_TO_PAGE_ERROR = 'Enter a valid number';
export const CHECK_FOR_NO_STRING_LITERAL = 'NO';
export const COLUMN_FOR_PRINT = 3;
export const COLUMN_FOR_E_FILE = 5;
export const POSITIVE_RESULT = 1;
export const NEGATIVE_RESULT = -1;
export const MAX_VISIBLE_ITEMS = 5;

export const INITIAL_PAGE_INDEX = 1;
export const VISIBLE_PAGES = 5;
export const ROWS_PER_PAGE = [10, 20, 30, 40];

export const ERROR_MESSAGE = 'Enter a valid number.';
export const NEXT_LABEL = 'Next';
export const PREVIOUS_LABEL = 'Previous';
export const PAGINATION_LABEL = 'Label';
export const RESULTS_PER_PAGE_LABEL = 'Items per page';
export const PAGE_LABEL = 'Page';
export const FILTER_BUTTON_TEXT_ARIA_LABEL = 'Apply Filters';
export const FILTER_BUTTON_TEXT = 'Filters';
export const ITEMS_PER_PAGE = 10;

export const FILTER_MODAL_TITLE =
  'Select category filters to enhance your search results.';
export const FILTER_MODAL_CLOSE_ARIA_LABEL = 'Close Modal';
export const FILTER_MODAL_Filter_BY = 'Filter by:';
export const FILTER_MODAL_CLEAR_BUTTON_TEXT = 'Clear filters';
export const FILTER_MODAL_CLEAR_ARIA_LABEL = 'Clear all filters';
export const FILTER_MODAL_CANCEL_BUTTON_TEXT = 'Cancel';
export const FILTER_MODAL_APPLY_BUTTON_TEXT = 'Apply Filters';
